__turbopack_context__.v({
  "disclaimers": "disclaimers-module-scss-module___Gthba__disclaimers",
  "disclaimers-container": "disclaimers-module-scss-module___Gthba__disclaimers-container",
  "global": "disclaimers-module-scss-module___Gthba__global",
});
